const { safeInternalPath } = require('../../router/safeInternalPath');

const TRAILER_VIDEO_ID_PREFIX = 'trailer:';

const playerPath = ({ type, id, videoId }) => [type, id, videoId].every((value) => typeof value === 'string' && value.length > 0)
    ? `/player/${[type, id, videoId].map(encodeURIComponent).join('/')}` : null;

const trailerPlayerPath = ({ type, id, ytId }) => typeof ytId === 'string' && ytId.length > 0
    ? playerPath({ type, id, videoId: TRAILER_VIDEO_ID_PREFIX + ytId })
    : null;

const trailerPlayerLink = (identity) => {
    const path = trailerPlayerPath(identity);
    return path ? `#${path}` : null;
};

const trailerIdFromVideoId = (videoId) => typeof videoId === 'string' && videoId.startsWith(TRAILER_VIDEO_ID_PREFIX) && videoId.length > TRAILER_VIDEO_ID_PREFIX.length
    ? videoId.slice(TRAILER_VIDEO_ID_PREFIX.length)
    : null;

const standaloneStreamFromPlayerLink = (link) => {
    const path = typeof link === 'string' ? safeInternalPath(link.replace(/^#/, '')) : null;
    if (!path) return null;
    const parts = path.split(/[?#]/, 1)[0].split('/');
    if (parts.length !== 3 || parts[1] !== 'player' || !parts[2]) return null;
    try {
        return decodeURIComponent(parts[2]);
    } catch (_) {
        return null;
    }
};

// Decode path segments only. The opaque stream is still decoded by Core.
const parsePlayerLink = (link) => {
    const path = typeof link === 'string' ? safeInternalPath(link.replace(/^#/, '')) : null;
    if (!path) return null;
    const parts = path.split(/[?#]/, 1)[0].split('/');
    if (parts[1] !== 'player') return null;
    try {
        if (parts.length === 5 && parts.slice(2).every(Boolean)) {
            const [type, id, videoId] = parts.slice(2).map(decodeURIComponent);
            return { canonical: true, type, id, videoId };
        }
        if (parts.length === 8 && parts[2]) {
            const [stream, streamTransportUrl, metaTransportUrl, type, id, videoId] = parts.slice(2).map(decodeURIComponent);
            if (playerPath({ type, id, videoId })) return { stream, streamTransportUrl, metaTransportUrl, type, id, videoId };
        }
    } catch (_) { return null; }
    return null;
};

const canonicalPlayerLink = (link) => {
    const selection = parsePlayerLink(link);
    // Standalone trailers have no content identity; preserve their existing route.
    if (!selection) return link;
    const query = link.includes('?') && new URLSearchParams(link.split('?')[1]).has('forceTranscoding') ? '?forceTranscoding' : '';
    return `${link.startsWith('#') ? '#' : ''}${playerPath(selection)}${query}`;
};

module.exports = {
    playerPath,
    trailerPlayerPath,
    trailerPlayerLink,
    trailerIdFromVideoId,
    standaloneStreamFromPlayerLink,
    parsePlayerLink,
    canonicalPlayerLink,
};
